<template>
  <div>
    <component :is="type + 'Icon'" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import ArchiveIcon from '../assets/archive-active.svg';
import ContactsIcon from '../assets/contacts-active.svg';
import ContentIcon from '../assets/content-active.svg';
import ContractsIcon from '../assets/contracts-active.svg';
import DashboardIcon from '../assets/dashboard-active.svg';
import DealboardIcon from '../assets/dealboard-active.svg';
import RoomsIcon from '../assets/rooms-active.svg';
import DocumentsIcon from '../assets/documents-active.svg';
import LibraryIcon from '../assets/library-active.svg';
import ProductsIcon from '../assets/products-active.svg';
import ReportsIcon from '../assets/reports-active.svg';
import type { SidebarLabel } from '../types/enums/sidebar-label';

export default defineComponent({
  name: 'GlobalSidebarIcon',
  components: {
    ArchiveIcon,
    ContactsIcon,
    ContentIcon,
    ContractsIcon,
    DashboardIcon,
    DealboardIcon,
    RoomsIcon,
    DocumentsIcon,
    LibraryIcon,
    ProductsIcon,
    ReportsIcon,
  },
  props: {
    type: {
      type: String as PropType<SidebarLabel>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
$icon-size: 1.5rem;

svg {
  width: $icon-size;
  height: $icon-size;
}
</style>
